// extracted by mini-css-extract-plugin
export default {"stack":"DashboardView-module__stack__287ce"};